import React from 'react';

export function Projects() {
  return (
    <div className="content-wrapper">
      <div className="left-side-bar">
        <nav className="left-side-bar__nav"></nav>
      </div>

      <div className="content">
        <div className="content__title">
          <div className="content__tab">
            personal-info <span className="content__close-btn"></span>
          </div>
        </div>

        <div className="content__cards">
          <div className="content__card">
            <div className="project-title">
              <span>Project 1</span> &#47;&#47; _website
            </div>
            <div className="project-content lazarevafoto">
              <span className="project-desc">
                Website of a professional photographer in Minsk
              </span>
              <a
                target="_blank"
                rel="noreferrer"
                className="project-refer"
                href="https://lazarevafoto.by/"
              >
                view-project
              </a>
            </div>
          </div>

          <div className="content__card">
            <div className="project-title">
              <span>Project 2</span> &#47;&#47; _SPA
            </div>
            <div className="project-content stickers">
              <span className="project-desc">
                Application for creating stickers on electric boards
              </span>
              <a
                target="_blank"
                rel="noreferrer"
                className="project-refer"
                href="http://stickers.ga/"
              >
                view-project
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
